import React, { useEffect, useState } from 'react';
import {IProps, IState, IHtmlTagDefinition} from './types';
import DivElement from './Elements/divElement'
import SpanElement from './Elements/spanElement'
import SubElement from './Elements/subElement'
import SupElement from './Elements/supElement'

const HtmlTagRendering:React.FC<IProps> = (props) => {
  return (
    <>
      {
        props.tagDefinition.tagName.toLowerCase() === "div" &&
        <DivElement {...props}/>
      }
      {
        props.tagDefinition.tagName.toLowerCase() === "span" &&
        <SpanElement {...props}/>
      }
      {
        props.tagDefinition.tagName.toLowerCase() === "sub" &&
        <SubElement {...props}/>
      }
      {
        props.tagDefinition.tagName.toLowerCase() === "sup" &&
        <SupElement {...props}/>
      }
    </>
  );
}

export default HtmlTagRendering;